import { IconName } from '@/components/Icon';

import { CountryISO } from '@/types/places';

export enum DocumentSection {
  ProofOfAddress = 'Proof_of_Address',
  ProofOfEmployment = 'Proof_of_Employment',
  ProofOfRelationship = 'Proof_of_Relationship',
  USCitizenshipRenouncement = 'US_Citizenship_Renouncement',
  TaxSupportingDocument = 'Tax_Supporting_Document',
  TIN = 'TIN_Number',
  DocumentSign = 'Document_Sign',
  Identity = 'Identity',
  Selfie = 'SN',
  IdentityBack = 'Identity_Back',
  SecondID = 'Second_ID',
  SecondCitizenshipID = 'Second_Citizenship_ID',
  IDVideo = 'ID_Video',
}

export enum DocumentType {
  AuthorisationLetter = 'Authorisation_Letter',
  AdoptionOrder = 'Adoption_Order',
  BankReferenceLetter = 'Bank_Reference_Letter',
  BankStatement = 'Bank_Statement',
  BirthCertificate = 'Birth_Certificate',
  CBBExtract = 'CBB_Extract',
  FamilyBook = 'Family_Book',
  StatementFromTheParentalAuthorityRegister = 'Statement_from_the_Parental_Authority_Register',
  CertificateOfLossOfNationality = 'Certificate_of_Loss_of_Nationality',
  CertificateOfTitle = 'Certificate_Of_Title',
  ConfirmationOfAddress = 'Confirmation_Of_Address',
  CopyOfUtilityBillOwnerID = 'Copy_Of_Utility_Bill_Owner_ID',
  DiplomaticIdOrTaxExemptionLetter = 'Diplomatic_ID_Or_Tax_Exemption_Letter',
  DriverLicense = 'Driver_License',
  ExtractFromChamberOfCommerce = 'Extract_From_Chamber_Of_Commerce',
  FinancialStatements = 'Financial_Statements',
  FinancialStatementsProjections = 'Financial_Statements_Projections',
  FireInsurance = 'Fire_Insurance',
  ForecastProjections = 'Forecast_Projections',
  FormI407Proof = 'Form_I_407_Proof',
  GemeenteUitreksel = 'Gemeente_Uitreksel',
  GuardianOrder = 'Guardian_Order',
  GovernmentCensusRegistrationForm = 'Government_Census_Registration_Form',
  Id = 'ID',
  IdentityDriverLicense = 'D',
  IncomeAndExpenditureStatement = 'Income_And_Expenditure_Statement',
  IncomeStatement = 'Income_Statement',
  ImmigrationStatusDocumentation = 'Immigration_Status_Documentation',
  LatestFiledTaxReturn = 'Latest_Filed_Tax_Return',
  LeaseAgreement = 'Lease_Agreement',
  LetterFromToshaosHinterlandLocations = 'Letter_From_Toshaos_Hinterland_Locations',
  LetterOfAuthorisationFromUtilityBillOwner = 'Letter_Of_Authorisation_From_Utility_Bill_Owner',
  LetterOfEmployment = 'Letter_Of_Employment',
  ManagementAccounts = 'Management_Accounts',
  MonthlyIncomeAndExpenditure = 'Monthly_Income_And_Expenditure',
  Nis = 'NIS',
  NotarizedStatement = 'Notarized_Statement',
  Other = 'Other',
  ParentID = 'Parent_ID',
  Passport = 'Passport',
  PostMarkedEnvelopeWithCustomerNameAndAddress = 'Post_Marked_Envelope_With_Customer_Name_And_Address',
  ProfessionalRecommendationLetter = 'Professional_Recommendation_Letter',
  ProjectedCashFlows = 'Projected_Cash_Flows',
  ProjectedIncomeStatement = 'Projected_Income_Statement',
  ProofOfCurrentAddress = 'Proof_Of_Current_Address',
  ProofOfIncomeFromCaretaker = 'Proof_Of_Income_From_Caretaker',
  ProofOfAddressFromCaretaker = 'Proof_Of_Address_From_Caretaker',
  ProofOfIncomeFromHusband = 'Proof_Of_Income_From_Husband',
  ProofOfAddressFromHusband = 'Proof_Of_Address_From_Husband',
  ProofOfAddressFromParent = 'Proof_Of_Address_From_Parent',
  ProofOfIncomeFromParent = 'Proof_Of_Income_From_Parent',
  HusbandId = 'Husband_ID',
  CaretakerId = 'Caretaker_ID',
  RecentBankStatement = 'Recent_Bank_Statement',
  ProofOfPropertyOwnershipNotarialDeed = 'Proof_Of_Property_Ownership_Notarial_Deed',
  RatesAndTaxesReceiptInvoice = 'Rates_And_Taxes_Receipt_Invoice',
  RecentPayslip = 'Recent_Payslip',
  RegistrationForm = 'Registration_Form',
  ResidencePermit = 'Residence_Permit',
  ResidencePermitWithPermissionToWork = 'Residence_Permit_With_Permission_To_Work',
  ResidencyVisaEntryPermitProof = 'Residency_Visa_Entry_Permit_Proof',
  SchoolLetterOfAttendance = 'School_Letter_Of_Attendance',
  SecurityCard = 'Security_card',
  SelfAttestationForProofOfAddress = 'Self_Attestation_For_Proof_Of_Address',
  SelfAttestationForProofOfIncome = 'Self_Attestation_For_Proof_Of_Income',
  Selfie = 'SN',
  SelfEmployedIncomeVerification = 'Self_Employed_Income_Verification',
  SocialSecurityLetter = 'Social_Security_Letter',
  SourceOfFunds = 'Source_of_Funds',
  SupportLetterFromCaretaker = 'Support_Letter_From_Caretaker',
  SupportLetterFromHusband = 'Support_Letter_From_Husband',
  SupportLetterFromParent = 'Support_Letter_From_Parent',
  SupportingLetter = 'Supporting_Letter',
  TaxExemptionDocument = 'Tax_Exemption_Document',
  TinCertificate = 'Tin_Certificate',
  TradeLicense = 'Trade_License',
  UtilityBill = 'Utility_Bill',
  UtilityBillNonOwner = 'Utility_Bill_Non_Owner',
  VideoAddSelfie = 'VSS',
  VoterID = 'Voter_ID',
  WorkPermitWorkVisa = 'Work_Permit_Work_Visa',
  EmploymentAuthorizationDocuments = 'Employment_Authorization_Documents',
  MissionaryPermit = 'Missionary_Permit',
  StudentVisa = 'Student_Visa',
  LetterOfEnrollmentFromEducationalInstitution = 'Letter_Of_Enrollment_From_Educational_Institution',
  CSMECertificate = 'CSME_Certificate',
  LocalBankReferenceLetter = 'Local_Bank_Reference_Letter',
  LocalBankStatement = 'Local_Bank_Statement',
  ForeignBankReferenceLetter = 'Foreign_Bank_Reference_Letter',
  ForeignBankStatement = 'Foreign_Bank_Statement',
  FirearmID = 'Firearm_ID',
  SeafarerID = 'Seafarer_ID',
  WorkPermitCard = 'Work_Permit_Card',
  National_Health_Insurance = 'National_Health_Insurance',
  SocialSecurityCard = 'Social_Security_Card',
  ImmigrationCard = 'Immigration_Card',
  Source_Of_Fund_From_Other = 'Source_Of_Fund_From_Other',
  Source_Of_Fund_From_Savings = 'Source_Of_Fund_From_Savings',
  Source_Of_Fund_From_Inheritance = 'Source_Of_Fund_From_Inheritance',
  Source_Of_Fund_From_Rental_Income = 'Source_Of_Fund_From_Rental_Income',
  Source_Of_Fund_From_Sale_Of_Asset = 'Source_Of_Fund_From_Sale_Of_Asset',
  Source_Of_Fund_From_Scholarship = 'Source_Of_Fund_From_Scholarship',
  Source_Of_Fund_From_Dividends = 'Source_Of_Fund_From_Dividends',
  Source_Of_Fund_From_Investments = 'Source_Of_Fund_From_Investments',
  Source_Of_Fund_From_Salary = 'Source_Of_Fund_From_Salary',
}

export const AML4IdentificationType: Record<string, string> = {
  [DocumentType.Passport]: 'passport',
  [DocumentType.IdentityDriverLicense]: 'driver_license',
  [DocumentType.DriverLicense]: 'driver_license',
  [DocumentType.Id]: 'nid',
};

export enum DocumentStatus {
  InReview = 'IN_REVIEW',
  Cancelled = 'CANCELLED',
  Rejected = 'REJECTED',
  Expired = 'EXPIRED',
  AboutToExpire = 'ABOUT_TO_EXPIRE',
  Approved = 'APPROVED',
  Completed = 'COMPLETED',
  Signing = 'SIGNING',
  Empty = 'EMPTY',
  Pending = 'PENDING',
  Requested = 'REQUESTED',
  DefaultApproved = 'DEFAULT_APPROVED',
}

export type Document = {
  id: number | string;
  fileName: string;
  status: DocumentStatus;
  type: DocumentSection;
  docType?: DocumentType | SigningFormType;
  vuOperationGuid?: number | string;
  vuOperationId?: number | string;
  adobeSignWidgetId?: string;
  createdAt: string;
  docNumber?: string;
  issueDate?: string;
  expiryDate?: string;
  uri?: string;
  issueCountry?: CountryISO;
  contentType?: string;
  infoConfirmed?: boolean;
  issueCity?: string;
  idmResultCode?: string;
};

export enum SourceType {
  Web = 'web',
  Image = 'img',
  PDF = 'pdf',
}

export type SigningDocument = {
  code: SigningFormType;
  id: string;
  name: string;
  url: string;
  sender: string;
  docType?: string;
  docTypeWithAccountType?: string;
  status?: DocumentStatus;
  formName?: string;
  prefillData?: Record<string, string>;
};

export enum SigningFormType {
  Authorization = 'CA43B_Account_Authorisation',
  W9 = 'W9_Request_for_TIN',
  FATCA_1A = 'FATCA1A_US_Personal_Status',
  CA43A = 'CA43A_Mandate',
  AML6 = 'AML6A_US_Tax',
  AML4A = 'AML4A_Personal_Information',
  AML4A_04_2025 = 'AML4A_Personal_Information_04_2025',
  AML4A_06_2025 = 'AML4A_Personal_Information_06_2025',
  SIGNATURE = 'Signature_Sheet',
  IDC = 'IDC_Agreement',
  ISC = 'Individual_Self_Certification',
  DOA = 'Digital_Account_Opening',
  AML10 = 'AML10_Statement_Of_Affairs',
  FV511 = 'FV511_Consent_For_A_Minor_Agreement',
}

export enum BugfenderTagType {
  DOCUMENT_SIGNING_FORM_LOADED = 'DOCUMENT_SIGNING_FORM_LOADED',
  DOCUMENT_SIGNING_FORM_SIGNED = 'DOCUMENT_SIGNING_FORM_SIGNED',
  MORE_INFO = 'MORE_INFO',
}
export enum AcrobatSignEventType {
  PageLoad = 'PAGE_LOAD',
  Signed = 'ESIGN',
  Rejected = 'REJECT',
  Prefilled = 'PREFILL',
}

export type AcrobatSignMessage = {
  type: AcrobatSignEventType;
  data?: Record<string, string>;
};

export type RequiredDocument = {
  displayHTML?: string;
  name: DocumentType;
  groupedAs?: DocumentType;
  groupedTypes?: DocumentType[];
  subtitle?: string;
  description?: string;
  status?: DocumentStatus;
  disabled?: boolean;
  icon?: IconName;
  downloadPath?: string;
  downloadFileName?: string;
};

export enum RequiredCondition {
  Or = 'or',
  And = 'and',
}

export type RequiredDocumentGroup = {
  condition: RequiredCondition;
  items: RequiredDocument[];
  status?: DocumentStatus;
  title?: string;
  subtitle?: string;
};

export type RequiredDocumentSection = {
  type: DocumentSection;
  displayText?: string;
  docs: string[];
  status?: DocumentStatus;
  description?: string;
  groups?: RequiredDocumentGroup[];
};

export type ConfirmSecondIdPayloadFormType = {
  docType: string;
  docNumber: string;
  issueDate?: string;
  expiryDate?: string;
  issueCountry: string;
};
